import { render, staticRenderFns } from "./SuitforEdit.vue?vue&type=template&id=00352872&scoped=true"
import script from "./SuitforEdit.vue?vue&type=script&lang=js"
export * from "./SuitforEdit.vue?vue&type=script&lang=js"
import style0 from "./SuitforEdit.vue?vue&type=style&index=0&id=00352872&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00352872",
  null
  
)

export default component.exports